import {Assignment, AssignmentPerType} from '@/models/assignments'
import {GroupBasic} from '@/models/group'
import BaseService from '@/services/BaseService'

export class AssignmentService extends BaseService<Assignment> {
  constructor() {
    super('assignments/')
  }

    public async fetchAssignmentsPerType(): Promise<AssignmentPerType> {
          const result = await this.instance.get('assignments-per-type/')
          return result.data
      }

    public async fetchAssignmentGroups(assignment): Promise<GroupBasic[]> {
          const result = await this.instance.get(this.resourcePath + assignment.id + '/group/', {
            params: {
              table: assignment.table,
            },
          })
          return result.data
      }
}

export default new AssignmentService()
